import { WidgetHelper } from '@/helpers/Widget'

import FabWidget from '@/modules/FabWidget/components/FabWidget'

WidgetHelper.registerOnce(FabWidget, '#fab-widget')
